/**
 * OAuth client ids for the SSO sign-in buttons. NOT secrets - a public
 * client id for a browser-based OAuth flow is meant to be embedded in
 * client-side code (there is no client secret in either provider's SPA
 * flow; the thing that actually protects this is avrio-backend's
 * SsoTokenVerifier checking the ID token's signature/issuer/audience
 * server-side, never the id's secrecy).
 *
 * KEEP IN SYNC BY HAND with avrio-backend's application.yml /
 * application-staging.yml / application-prod.yml `sso.google.client-id` /
 * `sso.microsoft.client-id` - same values, confirmed identical in both
 * environments there as of 2026-10-02. There is no shared schema between
 * the two repos, same reasoning as avrio-frontend's quote.ts keeping its
 * own copy of avrio-backend's rate card.
 */
export const GOOGLE_CLIENT_ID =
  '965872218072-k2qbte3cljlj5lfg42k6isjisfq66gi4.apps.googleusercontent.com';

export const MICROSOFT_CLIENT_ID = '947bcbd1-4778-4c85-9c1c-50332738428d';

/**
 * `common` accepts both personal Microsoft accounts and any Azure AD
 * organizational account - matching SsoTokenVerifier's own issuer check
 * server-side, which pins the issuer to the
 * `https://login.microsoftonline.com/{tenantId}/v2.0` SHAPE rather than one
 * fixed tenant, for exactly this multi-tenant case.
 */
export const MICROSOFT_AUTHORITY = 'https://login.microsoftonline.com/common';
